import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-choose',
  templateUrl: './why-choose.component.html',
  styleUrls: ['./why-choose.component.css']
})
export class WhyChooseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
